export const getUser = (state) => state.Auth;
export const getDashboard = (state) => state.Dashboard;

// export { region, city };
